/**
 * @fileoverview PUT handler for the "/companies/:company_id/developers/:developer_id/developer_clear_two_factor_auth" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdDevelopersDeveloperIdDeveloperClearTwoFactorAuthCacheKeys } from "./constants";
import type {
  PutCompaniesCompanyIdDevelopersDeveloperIdDeveloperClearTwoFactorAuthProps,
  CompaniesCompanyIdDevelopersDeveloperIdDeveloperClearTwoFactorAuthResult,
} from "./types";

export const putCompaniesCompanyIdDevelopersDeveloperIdDeveloperClearTwoFactorAuth = reactQueryMutationAdapter(
  companiesCompanyIdDevelopersDeveloperIdDeveloperClearTwoFactorAuthCacheKeys,
  (
    props: PutCompaniesCompanyIdDevelopersDeveloperIdDeveloperClearTwoFactorAuthProps
  ): Promise<CompaniesCompanyIdDevelopersDeveloperIdDeveloperClearTwoFactorAuthResult> => {
    // manipulate props here as needed {  }

    return fetch(
      `/companies/${props.companyId}/developers/${props.developerId}/developer_clear_two_factor_auth`,
      "PUT",
      props
    );
  }
);
